export const couponViewCheck = {
  path: '/api/v1/coupon',
  method: 'GET',
};

export const couponCreateCheck = {
  path: '/api/v1/coupon',
  method: 'POST',
};

export function getCoupon(couponId) {
  return {
    path: `coupon/${couponId}`,
    method: 'GET',
  };
}

export function getCouponView(couponId) {
  return {
    path: `coupon/${couponId}/view`,
    method: 'GET',
  };
}

export function searchCoupons(search, contentType) {
  return {
    accept: contentType,
    path: `coupon${search}`,
    method: 'GET',
  };
}

export function checkCoupon(tenantId) {
  return {
    path: `coupon/${tenantId}/check`,
    method: 'POST',
  };
}

export function createCoupon(stripeParams, couponRules, ruleType, createdBy, description) {
  return {
    path: 'coupon',
    body: JSON.stringify({
      createdBy,
      couponRules,
      description,
      stripeParams,
      ruleType,
    }),
    method: 'POST',
  };
}

export function updateCoupon(couponId, description) {
  return {
    path: `coupon/${couponId}`,
    method: 'PUT',
    body: JSON.stringify({
      description,
    }),
  };
}

export function deleteCoupon(couponId) {
  return {
    path: `coupon/${couponId}`,
    method: 'DELETE',
  };
}
